import { apiAthenas } from '@/services/api/apiAthenas'
import { ReportData } from '@/types/demandReports'

export async function getReportsData(demandId: string): Promise<ReportData[]> {
  const { data } = await apiAthenas.get<ReportData[]>(
    `demands/${demandId}/reports`
  )

  return data['reports']
}
